import React, { useState, useContext } from 'react'
import GithubContext from '../../context/github/Githubcontext'
import AlertContext from '../../context/alert/AlertContext'
import { searchUsers } from '../../context/github/GithubAction'

const Usersearch = () => {
  const [text, setText] = useState('')

  const { users, dispatch} = useContext(GithubContext)
  const { setAlert} = useContext(AlertContext)

  const handleChange = (e) => {
    setText(e.target.value)
  }

  const handleSubmit = async(e) => {
    e.preventDefault()
    if (text === '') {
      setAlert('Please enter a search parameter', 'error')
    } else {
      //submit
      dispatch({type: 'SET_LOADING'})
      const users = await searchUsers(text)
      dispatch({
        type: 'SEARCH_USERS',
        payload: users
      })
      setText('')
    }
  }
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 mb-8 gap-8">
      <div>
        <form onSubmit={handleSubmit}>
          <div className="form-control">
            <div className="relative">
              <input
                type="text"
                className="w-full pr-40 bg-gray-200 input input-lg text-black"
                placeholder="search"
                value={text}
                onChange={handleChange}
              />
              <button
                type="submit"
                className="absolute top-0 right-0 rounded-l-none w-36 btn btn-lg"
              >
                Go
              </button>
            </div>
          </div>
        </form>
      </div>
      {users.length > 0 ? (
        <div>
          <button onClick={()=>dispatch({
            type: 'CLEAR_USERS'
          })} className="btn btn-ghost btn-lg">Clear</button>
        </div>
      ) : null}
    </div>
  )
}

export default Usersearch
